export default __webpack_public_path__ + "static/media/Power.1e1fc247.jpg";